import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {take} from 'rxjs/operators';

/** Remplace l’ancienne URL `?section=` par le segment de chemin correspondant. */
const LEGACY_SECTION_TO_PATH: Record<string, string> = {
  produit: 'produits',
  client: 'clients',
  fournisseur: 'fournisseurs',
  stock: 'stock'
};

@Component({
  selector: 'app-parametre-donnees-shell',
  templateUrl: './parametre-donnees-shell.component.html',
  styleUrls: ['./parametre-donnees-shell.component.scss']
})
export class ParametreDonneesShellComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(take(1)).subscribe((q) => {
      const raw = q['section'] as string | undefined;
      if (!raw) {
        return;
      }
      const path = LEGACY_SECTION_TO_PATH[raw];
      if (!path) {
        return;
      }
      this.router.navigate(['/main/parametre/donnees', path], {
        replaceUrl: true,
        queryParams: {}
      });
    });
  }
}
